import { render, staticRenderFns } from "./AllAccesses.vue?vue&type=template&id=3a2c2334&"
import script from "./AllAccesses.vue?vue&type=script&lang=js&"
export * from "./AllAccesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports